export enum ParamKeyEnum {
  CallbackUrl = 'callbackUrl',
  FlowId = 'flowId',
  InterviewId = 'interviewId',
}
